import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Skeleton,
  IconButton,
} from '@mui/material';
import { ProfileCardProps } from '../../types/profile.types';
import ColorData from 'Components/CstmTheme/ColorData';

const ProfileCard: React.FC<ProfileCardProps> = ({
  title,
  children,
  actions,
  loading = false,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        border: `1px solid ${ColorData.stroke.main}`,
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <CardHeader
        title={
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: ColorData.heading.main,
              fontSize: '1.1rem',
            }}
          >
            {title}
          </Typography>
        }
        action={actions}
        sx={{
          pb: 1,
          '& .MuiCardHeader-action': {
            alignSelf: 'center',
          },
        }}
      />
      <CardContent sx={{ pt: 0 }}>
        {loading ? (
          <Box>
            <Skeleton variant="text" width="80%" height={24} />
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="70%" height={24} />
          </Box>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
};

export default ProfileCard;